import rocketCrash from '@/assets/images/rocket/rocket_crash.svg'
import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { theme } from '@/theme/theme'

const ErrorCampaignTimeFrame: FC = () => {
  const { t } = useTranslation()
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent={'center'}
      minHeight={242}
      paddingTop={3}>
      <Typography textAlign="center" fontWeight={theme.typography.fontWeightMedium}>
        {t('campaignDashboard.timeFrame.error')}
      </Typography>
      <Box
        component="img"
        src={rocketCrash}
        alt="Rocket Base"
        sx={{
          height: 170,
        }}
      />
      <Typography textAlign="center" fontSize={14} fontWeight={theme.typography.fontWeightMedium}>
        {t('campaignDashboard.timeFrame.pleaseContact')}
      </Typography>
      <Typography textAlign="center" fontWeight={theme.typography.fontWeightBold}>
        {t('campaignDashboard.timeFrame.supportEmail')}
      </Typography>
    </Box>
  )
}

export default ErrorCampaignTimeFrame
